import React from 'react';

// Custom React components
import Result from './partial.result.js';
import MoreThanTen from './input.more-than-ten';
import StartDateInput from './input.start-date';
import WrittenNotice from './input.written-notice';
import ReceiptDateInput from './input.receipt-date';
import KindOfNoticeInput from './input.kind-of-notice';
import SpecialProtection from './input.special-protection';

// Custom Functions
import {
    is3WeeksAgo,
    hasMoreThanTen, 
    hasStarted6MonthsAgo,
    isInstantTermination,
} from '../functions/protection-calculator';

let maxSlides = 4;

class Check extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            // form inputs
            kindOf: "",
            moreThanTen: "",
            writtenNotice: "",
            specialProtection: "",
            startDate: null,
            receiptDate: null,
            // form position tracker
            currentQuestion: 0,
            previousQuestion: 0,
            // result shower
            answerIsFix: false,
        }

        this.updateKindOf = this.updateKindOf.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.showPreviousField = this.showPreviousField.bind(this);
        this.updateReceiptDate = this.updateReceiptDate.bind(this);
        this.updateMoreThanTen = this.updateMoreThanTen.bind(this);
        this.updateWrittenNotice = this.updateWrittenNotice.bind(this);
        this.updateSpecialProtection = this.updateSpecialProtection.bind(this);
    }

    showNextField(position) {
        const { currentQuestion } = this.state;
        setTimeout(() => {
            this.setState({
                previousQuestion: currentQuestion,
                currentQuestion: (position < maxSlides) 
                    ? position
                    : maxSlides,
            });
        }, 0);
    }

    showPreviousField() {
        const { previousQuestion, currentQuestion } = this.state;
        let previous;

        if(previousQuestion > currentQuestion) {
            previous = currentQuestion - 1;
            previous = previous < 0 ? 0 : previous;
        } else {
            previous = previousQuestion;
        }

        setTimeout(() => {
            this.setState({
                answerIsFix: false,
                currentQuestion: previous,
                previousQuestion: currentQuestion
            });
        }, 0);
    }

    updateWrittenNotice(value) {
        this.setState({ writtenNotice: value }, () => {
            const isWrittenNotice = (this.state.writtenNotice == 1);
            if(isWrittenNotice) {
                this.showNextField(1);
            }
            this.setState({
                // if the notice is not written, it's over here.
                answerIsFix: !isWrittenNotice,
            });
        });
    }

    updateReceiptDate(day) {
        this.setState({ receiptDate: day }, () => {
            const isMoreThan3WeeksAgo = is3WeeksAgo(this.state);
            if(!isMoreThan3WeeksAgo) {
                maxSlides += 1;
                this.showNextField(2);
           }
           this.setState({
               // if the notice is older than 3 weeks, it's over here.
               answerIsFix: isMoreThan3WeeksAgo,
           });
        });
    }

    updateKindOf(value) {
        this.setState({ kindOf: value }, () => {
            const isInstant = isInstantTermination(this.state);
            if(!isInstant) {
                maxSlides += 1;
                this.showNextField(3);
           }
           this.setState({
               // if it's an instant notice, it's over here.
               answerIsFix: isInstant,
           });
        });
    }
    
    updateStartDate(day) {
        this.setState({ startDate: day }, () => {
            const started6MonthsAgo = hasStarted6MonthsAgo(this.state);
            if(started6MonthsAgo) {
                this.showNextField(4);
            } else {
                this.showNextField(5);
            }
            this.setState({
                // we need more information. No stop here.
                answerIsFix: false,
            });
        });
    }

    updateMoreThanTen(value) {
        this.setState({ moreThanTen: value }, () => {
            const hasMoreThaTen = (this.state.moreThanTen == 1);
            if (!hasMoreThaTen) {
                maxSlides += 1;
                this.showNextField(5);
            }
            this.setState({
                // if more than ten + longer than 6 month, we got our answer.
                answerIsFix: hasMoreThaTen,
            });
        });
    }

    updateSpecialProtection(value) {
        this.setState({
            // no more questions. tell him the truth.
            answerIsFix: true,
            specialProtection: value
         });
    }

    render() {
        return (
            <section className="check">
                <article className="blue-bar questions">
                    <WrittenNotice
                        writtenNotice={this.state.writtenNotice}
                        position={this.state.currentQuestion}
                        updateWrittenNotice={this.updateWrittenNotice}
                    />
                    
                    <ReceiptDateInput 
                        date={this.state.receiptDate}
                        position={this.state.currentQuestion}
                        showPreviousField={this.showPreviousField}
                        updateReceiptDate={this.updateReceiptDate} 
                    />

                    <KindOfNoticeInput 
                        kindOf={this.state.kindOf}
                        updateKindOf={this.updateKindOf}
                        position={this.state.currentQuestion}
                        showPreviousField={this.showPreviousField}
                    />

                    <StartDateInput 
                        date={this.state.startDate}
                        position={this.state.currentQuestion}
                        updateStartDate={this.updateStartDate} 
                        showPreviousField={this.showPreviousField}
                    />

                    <MoreThanTen
                        position={this.state.currentQuestion}
                        moreThanTen={this.state.moreThanTen}
                        updateMoreThanTen={this.updateMoreThanTen}
                        showPreviousField={this.showPreviousField}
                    />

                    <SpecialProtection
                        position={this.state.currentQuestion}
                        specialProtection={this.state.specialProtection}
                        updateSpecialProtection={this.updateSpecialProtection}
                        showPreviousField={this.showPreviousField}
                    />
                </article>

                { /* Result */}
                <article className={`blue-bar answer ${this.state.answerIsFix ? 'fade-in' : ''}`}>
                    <Result
                        state={this.state}
                        position={this.state.currentQuestion}
                        hasMoreThanTen={hasMoreThanTen(this.state)}
                        isMoreThan3WeeksAgo={is3WeeksAgo(this.state)}
                        isInstantTermination={isInstantTermination(this.state)}
                        hasStarted6MonthsAgo={hasStarted6MonthsAgo(this.state)}
                        isWrittenNotice={this.state.writtenNotice === 1}
                        hasSpecialProtection={this.state.specialProtection === 1}
                    />
                </article>
            </section>
        );
    }
}

export {
    maxSlides
}
export default Check;


// WEBPACK FOOTER //
// ./src/components/check.js